/** @jsx jsx */
import { useColors } from '@composite';
import { Box, jsx } from '@themed';
import { Institution } from '@types';
import React from 'react';
import { Header } from 'src/components/composite/finnoscore-comparison/Charts';
import { InstitutionGroupedDropDown } from '../../../finnoscore-comparison/InstitutionGroupedDropDown';
import { containerStyles } from '../../comparison/components';
import { ComparisonChartWithLabel } from '../../comparison/components/ComparisonChartWithLabel';

interface Props {
  pastInstitute: Institution;
  currentInstitute: Institution;
  pastYear?: string;
  currentYear?: string;
}
export const HistoryBubble = React.forwardRef<HTMLDivElement, Props>(({ pastInstitute, currentInstitute }, ref) => {
  const [[pastColor, currentColor]] = useColors();

  return (
    <Box sx={containerStyles} ref={ref}>
      <Box id='institutionDropdown'>
        <InstitutionGroupedDropDown
          isOpen={false}
          disabled
          setIsOpen={() => console.log()}
          onSelect={() => console.log()}
          selectedInstitution={pastInstitute}
          institutionColor={pastColor}
        />
        <InstitutionGroupedDropDown
          isOpen={false}
          disabled
          setIsOpen={() => console.log()}
          onSelect={() => console.log()}
          selectedInstitution={currentInstitute}
          institutionColor={currentColor}
        />
      </Box>

      <ComparisonChartWithLabel id='chart' dimension={currentInstitute.dimensions} relativeDimension={pastInstitute.dimensions}>
        <Header sx={{ background: 'none !important' }} />
      </ComparisonChartWithLabel>
    </Box>
  );
});
